import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material'
import { filter, flatten, isEmpty, isNull, map } from 'lodash'
import PropTypes from 'prop-types'

import { WarnIcon } from '../../icons'

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '& td, & th': {
    border: 0,
  },
}))

function DigitalCertificateWorksTodo({ certificateData }) {
  const { t } = useTranslation()

  const { technicalConditions } = certificateData
  const notOkElements = flatten(
    map(technicalConditions.getTechnicalConditionGroupModel, (group) =>
      filter(
        group.technicalChecklistGroupElements,
        (elem) => elem.technicalConditionStatus === 'NotOk',
      ),
    ),
  )

  return isNull(technicalConditions) || isEmpty(notOkElements) ? (
    t('controlsEditNoRepairs')
  ) : (
    <Paper elevation={0}>
      <Table>
        <TableBody>
          {map(notOkElements, (elem, key) => (
            <StyledTableRow key={key}>
              <TableCell>
                <Box sx={{ display: 'flex' }}>
                  <Box
                    sx={(theme) => ({
                      color: theme.palette.warning.main,
                    })}
                  >
                    <WarnIcon />
                  </Box>
                  <Box sx={{ ml: 1 }}>
                    <Typography>{elem.technicalChecklistItemName}</Typography>
                    {elem.description && (
                      <Typography
                        component="span"
                        variant="body2"
                        sx={({ palette }) => ({
                          color: palette.text.disabled,
                        })}
                      >
                        {elem.description}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  )
}

DigitalCertificateWorksTodo.propTypes = {
  certificateData: PropTypes.object,
}

DigitalCertificateWorksTodo.defaultProps = {
  certificateData: null,
}

export default DigitalCertificateWorksTodo
